<template>
    <main class="dashboard">
        <Header />
        <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253);">
            <div class="container">
                <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`" @click="() => back()"
                    class="volverButton">
                    <span style="font-size: 20px;"><img :src="arrow" class="arrow" /> Volver</span>
                </SimpleButton>
                <h3 class="title is-2 has-text-centered pt-3">
                    {{ basicData.company_name }} {{ this.companyRut }}
                </h3>
                <div class="is-relative plainCard has-text-centered is-clipped has-background-white">
                    <p class="has-text-primary-dark is-uppercase has-text-weight-semibold"
                        style="text-overflow:ellipsis; white-space: nowrap; overflow: hidden"
                        :title="basicData.nameContact">
                        Empresa {{ basicData.company_type }}
                    </p>
                </div>
                <div class="pane_container">
                    <div class="left-pane">
                        <SimpleButton
                            :class="['side_button', {'activeButton': activeButton == 'basic'}]"
                            @click="() => showContent('basic')">
                            Datos Basicos
                        </SimpleButton>
                        <SimpleButton
                            :class="['side_button', {'activeButton': activeButton == 'businessType'}]"
                            @click="() => showContent('businessType')">
                            Tipo de Negocio
                        </SimpleButton>
                        <SimpleButton
                            :class="['side_button', {'activeButton': activeButton == 'accountPlan'}]"
                            @click="() => showContent('accountPlan')">
                            Plan de Cuentas
                        </SimpleButton>
                        <SimpleButton
                            :class="['side_button', {'activeButton': activeButton == 'categories'}]"
                            @click="() => showContent('categories')">
                            Categorias
                        </SimpleButton>
                    </div>
                    <div class="right-pane">
                        <div id="basic" class="pane data_pane">
                            <CompanyInfoBasicData :basicData="basicData"/>
                        </div>
                        <div id="businessType" class="pane data_pane">
                            <CompanyInfoBusinessType  :basicData="basicData"/>
                        </div>
                        <div id="accountPlan" class="pane" >Plan de Cuenta</div>
                        <div id="categories" class="pane">Categorias</div>
                    </div>
                </div>
                <p class="title is-3 has-text-centered">Entrada de datos</p>
                <table class="table is-striped is-hoverable is-fullwidth has-text-centered">
                    <thead>
                        <tr>
                            <th>Entrada</th>
                            <th>Última Actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="file in fileData " v-bind:key="file.fileType">
                            <td class="content is-vcentered">
                                <SimpleButton :buttonStyle="`linear-gradient(225deg, #f5f5f9, #fafaff)`"
                                    @click="openFileModal(file.file_id, file.desc)">{{ file.desc }}</SimpleButton>
                            </td>
                            <td>
                                {{ moment(file.latest_date).format('DD-MM-YYYY') }}
                                <p v-if="!isLessThanMonth(file.latest_date)">
                                    <strong>(Atraso)</strong>
                                </p>
                                <p class="" v-if="!file.uploaded && isLessThanMonth(file.latest_date)">
                                    <strong>(Problema en el archivo)</strong>
                                </p>
                            </td>
                            <td class="content is-vcentered">
                                <!-- {{ file.uploaded }} -->
                                <p>
                                    <!-- a v-if="!file.uploaded || !isLessThanMonth(file.latest_date)"
                                        class="mr-3"><u>Solicitar</u></a -->
                                    <SimpleButton :buttonStyle="`linear-gradient(225deg, #faf5f5, #fff0f0)`"
                                        @click="openSolicitarArchivo(file.file_id)">Solicitar</SimpleButton>
                                    <SimpleButton :buttonStyle="`linear-gradient(225deg, #f5faf5, #f0fff0)`"
                                        @click="openUploadFileUsers(file.file_id)">Subir</SimpleButton>
                                    <a v-if="false"><u>Soporte </u></a>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </main>
</template>

<script>
import { getDetalleCompania } from "@/api/carteraAnalista";
import { getFilesUsersByCompany } from "@/api/uploadFiles";
import Header from "@/components/dashboard/Header";
import CompanyUploads from "@/components/modals/CompanyUploads";
import SimpleButton from "@/components/modals/SimpleButton";
import UploadFileAsUserModal from "@/components/modals/UploadFileAsUserModal";
import CompanyInfoBasicData from "@/views/CompanyInfo_BasicData";
import CompanyInfoBusinessType from "@/views/CompanyInfo_BusinessType";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "CompanyInfo",
    components: {
        Header,
        SimpleButton,
        CompanyInfoBasicData,
        CompanyInfoBusinessType,
    },
    created() {
        const companyId = this.$route.query.companyId;
        this.companyRut = this.$route.query.companyRut;
        if (!companyId) {
            this.$router.push({ name: 'panel-analista' });
        } else {
            this.fetchCompanyData(companyId);
        }
        getFilesUsersByCompany(companyId).then(({ data }) => {
            this.allFilesByUser = data
        })
    },
    mounted() {
        this.showContent('basic');
    },
    data() {
        return {
            activeButton: '',
            publicPath: "http://" + window.location.hostname,
            modalDefault: {
                parent: this,
                hasModalCard: true,
                width: '99%',
                height: 1000,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
                "full-screen": true,
            },
            modalDefaultUpdateSheet: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
            basicData: {},
            fileData: [],
            allFilesByUser: [],
            companyRut: '',
            loadingReloadDrive: false,
        };
    },
    computed: {
        ...mapState("userAuth", ["user"]),
        arrow() { return `${this.publicPath}/arrow-back-128.png`; }
    },
    methods: {
        async fetchCompanyData(id) {
            try {
                const resp = await getDetalleCompania(id, true);
                this.basicData = resp.data;
                this.basicData.companyId = parseInt(id);
                this.fileData = Object.values(this.basicData['file_data']);
                this.fileData.sort((a, b) => a.order - b.order);
            } catch (error) {
                console.error('Error fetching company details:', error);
            }
        },
        back() {
            window.location.href = "#/panel-analista";
        },
        showContent(contentId) {
            this.activeButton = contentId;
            var contents = document.querySelectorAll('.pane');
            contents.forEach(function(content) {
                content.style.display = 'none';
            });

            var activeContent = document.getElementById(contentId);
            activeContent.style.display = 'block';
        },
        onModalClose() {
            this.fetchCompanyData(this.basicData.companyId);
        },
        moment(date) {
            return moment(date);
        },
        isLessThanMonth(date) {
            let today = moment()
            let monthBefore = today.subtract(1, 'months')
            let compareDate = moment(date)
            return monthBefore <= compareDate
        },
        openFileModal(id, file_desc) {
            this.basicData['file_id'] = id;
            this.basicData['file_desc'] = file_desc;
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: CompanyUploads,
                props: {
                    basicData: this.basicData,
                },
            });
        },
        openUploadFileUsers(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter(fileUser => {
                let fileFinded = fileUser.files.filter(file => file.id == fileId)
                return fileFinded.length > 0
            })
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: false,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    }
                },
            });
        },
        openSolicitarArchivo(fileId) {
            let allUsersByFileId = this.allFilesByUser.filter(fileUser => {
                let fileFinded = fileUser.files.filter(file => file.id == fileId)
                return fileFinded.length > 0
            })
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: UploadFileAsUserModal,
                canCancel: ['escape', 'button', 'outside'],
                onCancel: () => this.onModalClose(),
                props: {
                    fileId,
                    idCompany: this.basicData.companyId,
                    hideHistoricBtn: false,
                    selectedFilesByUser: allUsersByFileId,
                    sendMail: true,
                },
                events: {
                    close: () => {
                        this.onModalClose();
                    }
                },
            });
        },
    }
};
</script>
<style scoped>
.archivo_button {
    border-radius: 1px;
    border: 0;
    padding: 2px 5px;
    background-image: linear-gradient(225deg, #f5f5f5, #fafafa);
    white-space: nowrap;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.archivo_button:hover {
    transform: translateY(-2px);
    filter: drop-shadow(-1px 1px 3px #d0d0d0ff);
}

.archivo_button:active {
    transform: translateY(1px);
}

.is-secondary {
    margin-left: 10px;
}

.simple_button_extra {
    border: 1px solid #c0c0ff;
}

.volverButton {
    position: absolute;
    top: 20px;
    right: 10px;
}

.arrow {
    text-align: bottom;
    height: 22px;
    padding-top: 4px;
}

.pane_container {
    display: flex;
    height: 100vh;
}
.left-pane {
    min-width: 154px;
    max-width: 154px;
    width: 154px;
    box-sizing: border-box;
    padding-top: 45px;
}
.right-pane {
    flex: 1;
    box-sizing: border-box;
}
.pane {
    display: none;
}
.side_button {
    padding: 6px 20px 6px 20px;
    margin-bottom: 15px;
    background: linear-gradient(225deg, #eff9ff, #fafdff);
}
.data_pane {
    margin: 20px;
}
.activeButton {
    border: 2px solid #000000;
    background: linear-gradient(225deg, #eeffdd, #ffeeaa) !important;
}
</style>